import React from 'react';
import { RegIcon, PadlockIcon } from "svg/icons";
import { useTranslate } from 'context/LanguageContext';

const links = [
	{
		class: "reg",
		label: "registration",
		svg: <RegIcon/>,
		href: "https://konto.um.gdynia.pl/registration"
	},
	{
		class: "login",
		label: "sign_in",
		svg: <PadlockIcon/>,
		href: "https://konto.um.gdynia.pl/login"
	}
]

export default function HeaderAppButtons() {
	
	const translate = useTranslate();

	return (
		<div className="header__app-buttons">
			{ links.map( l => (
				<a
					key={ l.href }
					href={ l.href }
					className={ l.class }
					target="_blank"
				>
					
					<span> { translate( l.label )} </span>
					{ l.svg }
				</a>
			))}
		</div>
	)
}

